(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('');
        $sessionStorageProvider.setKeyPrefix('');
    }
})();
